import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-supervisores',
  templateUrl: './supervisores.component.html',
  styleUrls: ['./supervisores.component.scss']
})
export class SupervisoresComponent implements OnInit {

  usuario: any;
  supervisores: any[];
  supervisoresFiltrados: any[] = [];
  guardias: any[];
  instalacionesFiltradas: any[];
  instalacionesAsignadas: any[] = [];
  instalaciones: any[];
  estaEditando: boolean = false;
  modoCreaEdita: boolean = false;
  muestraEliminados: boolean = false;
  formulario: FormGroup;
  estadoCivil: any[];

  regiones: any[];
  comunas: any[];
  regionescomunas: any[];
  comunasFiltradas: any[];

  fechaInicial: Date = new Date(1980, 0, 1);
  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone,
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.formulario = this.formBuilder.group({
      _id: '',
      Nombre: ['', Validators.required],
      Codigo: [{ value: '', disabled: true }],
    });

    this.getAllSupervisores();
    this.getInstalaciones();
  }

  async ngOnInit(): Promise<void> {
    console.log(this.estadoCivil);
    console.log('fechaInicial', this.fechaInicial);
  }

  nuevo() {
    console.log('pasṕ por nuevo');

    this.estaEditando = false
    this.modoCreaEdita = true
    console.log('this.estaEditando', this.estaEditando);
  }

  searchInstalacion(event) {
    console.log('instalaciones:', this.instalaciones);

    var filtered: any[] = [];
    var query = event.query;
    for (let i = 0; i < this.instalaciones.length; i++) {
      let param = this.instalaciones[i];
      if (param.Nombre.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(param);
      }
    }
    this.instalacionesFiltradas = filtered;
    console.log('this.instalacionesFiltradas', this.instalacionesFiltradas);

  }

  seleccionaInstalacion(event) {
    console.log(event)

    let index = this.instalacionesAsignadas.findIndex(e => e._id == event._id)
    if (index > -1)
      return;

    this.instalacionesAsignadas.push({
      _id: event._id,
      Nombre: event.Nombre
    })
    console.log('instalacionessAsignadas', this.instalacionesAsignadas);

  }

  deleteInstalacionAsignada(id) {

    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        const index = this.instalacionesAsignadas.findIndex(e => e._id == id)
        this.instalacionesAsignadas.splice(index, 1)
      },
      reject: () => {
        return;
      }
    });


  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);

    const yaEstaEliminado = this.supervisores.find(e => e._id == id).Eliminado
    console.log('yaEstaEliminado', yaEstaEliminado);

    let eliminacionTotal = false

    let message = 'Estás seguro?'
    if (yaEstaEliminado) {
      message = 'El supervisor ya está eliminado. Si continúa se eliminará definitivamente. Estás seguro?'
      eliminacionTotal = true
    }
    this.confirmationService.confirm({
      target: event.target,
      message: message,
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteSupervisorService(id, eliminacionTotal)
          .subscribe((data: any) => {
            console.log(data);
            this.getAllSupervisores();

            this.messageService.add({
              severity: "info",
              summary: "Eliminado!",
              detail: data  // Devuelve la cantidad de instalaciones
            });
          })
      },
      reject: () => {
        return;
      }
    });

  }

  guardar(_formValue) {

    let formValue = JSON.parse(JSON.stringify(_formValue))
    formValue.Empresa = this.usuario.Empresa._id

    formValue.Instalaciones = this.instalacionesAsignadas

    console.log('formValue', formValue);

    if (this.estaEditando) {

      this.http.updateSupervisorService(formValue).subscribe((data: any) => {
        console.log('data', data);
        this.getAllSupervisores()
        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: 'Registro editado'
        });

        this.modoCreaEdita = false;
        this.estaEditando = false;

        this.limpiaFormulario()
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
      })

      return;
    }

    this.http.newSupervisorService(formValue).subscribe((data: any) => {
      console.log('data', data);
      this.getAllSupervisores()
      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: data  // Le muestro la cantidad de instalaciones que tiene
      });

      this.modoCreaEdita = false;
      this.limpiaFormulario()
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    })

  }

  async getAllSupervisores(): Promise<void> {
    this.supervisores = await this.http.getAllSupervisoresService();
    console.log('supervisores', this.supervisores);

    this.supervisores = this.supervisores.filter(e => e.Empresa.EmpresaMaster == false)
    this.supervisores = this.supervisores.filter(e => e.Empresa.NombreEmpresa != 'MARIANA YANEZ')
    this.supervisores = this.supervisores.filter(e => e.Empresa.NombreEmpresa != 'MARIANA YAÑEZ')

    this.supervisoresFiltrados = this.supervisores.filter(e => e.Eliminado == this.muestraEliminados)

    this.ngZone.run(() => { })
  }

  async getInstalaciones(): Promise<void> {
    this.instalaciones = await this.http.getinstalacionesByEmpresaService(this.usuario.Empresa._id);
    console.log('instalaciones', this.instalaciones);
  }

  abreModaledita(id) {
    console.log('id:', id);

    this.estaEditando = true
    this.modoCreaEdita = true
    let index = this.supervisores.findIndex(e => e._id == id)

    let supervisor = this.supervisores[index]

    this.instalacionesAsignadas = supervisor.Instalaciones

    console.log('supervisor', supervisor);

    this.formulario.patchValue(supervisor)
  }


  limpiaFormulario() {
    this.formulario.reset()
    this.modoCreaEdita = false
    this.estaEditando = false
    this.instalacionesAsignadas = []
  }

  cambiaActivo() {
    console.log('cambiaActivo');
    this.supervisoresFiltrados = this.supervisores.filter(e => e.Eliminado == this.muestraEliminados)
  }


}
